import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import JumpToGroup from "./JumpToGroup";
const JumpToGroups = (props)=>{
    const { groups , getItemProps , collapsible  } = props;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: groups.map(({ group , items  })=>{
            return /*#__PURE__*/ _jsx(JumpToGroup, {
                title: group,
                items: items,
                getItemProps: getItemProps,
                collapsible: collapsible
            }, group);
        })
    });
};
export default JumpToGroups;
